export default __webpack_public_path__ + "static/media/changeLog.78d72114.md";